import React from 'react'
import {KTIcon} from '../../../../_metronic/helpers'
import type {ContactoSocio} from '../contactoSocio'
import {nombreContactoCompleto} from '../contactoSocio'

type SocioContactosModalProps = {
  show: boolean
  onClose: () => void
  contactos: ContactoSocio[]
  isEditing: boolean
  onEdit: (c: ContactoSocio) => void
  onDelete: (idContacto: number) => void
  onAdd: () => void
}

export const SocioContactosModal: React.FC<SocioContactosModalProps> = ({
  show,
  onClose,
  contactos,
  isEditing,
  onEdit,
  onDelete,
  onAdd,
}) => {
  if (!show) return null

  const ordenados = [...contactos].sort((a, b) =>
    nombreContactoCompleto(a).localeCompare(nombreContactoCompleto(b))
  )

  return (
    <>
      <div
        className='modal-backdrop fade show'
        style={{zIndex: 1990}}
        onClick={onClose}
        aria-hidden
      />
      <div
        className='modal fade show d-block'
        tabIndex={-1}
        role='dialog'
        aria-modal='true'
        style={{zIndex: 1995}}
      >
        <div className='modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h2 className='modal-title fw-bold d-flex align-items-center'>
                <KTIcon iconName='people' className='fs-2hx text-primary me-3' />
                Contactos adicionales
              </h2>
              <div className='d-flex align-items-center gap-2'>
                <button
                  type='button'
                  className='btn btn-icon btn-sm btn-active-light-primary'
                  onClick={onClose}
                  aria-label='Cerrar'
                >
                  <KTIcon iconName='cross' className='fs-1' />
                </button>
              </div>
            </div>
            <div className='modal-body py-5'>
              {ordenados.length === 0 ? (
                <div className='text-center py-10'>
                  <KTIcon iconName='user-tick' className='fs-3x text-gray-400 mb-4' />
                  <div className='text-gray-700 fw-semibold fs-5 mb-2'>
                    No hay contactos adicionales registrados
                  </div>
                  <div className='text-muted fs-6 mb-6'>
                    Los contactos adicionales aparecerán aquí cuando estén cargados en el socio.
                  </div>
                  {isEditing ? (
                    <button type='button' className='btn btn-primary' onClick={onAdd}>
                      <KTIcon iconName='plus' className='fs-4 me-2' />
                      Agregar contacto
                    </button>
                  ) : null}
                </div>
              ) : (
                <div className='table-responsive'>
                  <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                    <thead>
                      <tr className='fw-bold text-muted bg-light'>
                        <th className='ps-4 rounded-start'>Nombre</th>
                        <th>Email</th>
                        <th>Teléfono</th>
                        <th>Cargo</th>
                        <th className='text-center'>Estado</th>
                        {isEditing ? (
                          <th className='text-center rounded-end pe-4'>Acciones</th>
                        ) : null}
                      </tr>
                    </thead>
                    <tbody>
                      {ordenados.map((contacto) => (
                        <tr key={contacto.id}>
                          <td className='ps-4'>
                            <span className='text-dark fw-bold fs-6'>
                              {nombreContactoCompleto(contacto)}
                            </span>
                          </td>
                          <td>
                            <span className='text-muted fw-semibold d-block fs-7'>
                              {contacto.email || '—'}
                            </span>
                          </td>
                          <td>
                            <span className='text-muted fw-semibold d-block fs-7'>
                              {contacto.telefono || '—'}
                            </span>
                          </td>
                          <td>
                            <span className='text-muted fw-semibold d-block fs-7'>
                              {contacto.cargo || '—'}
                            </span>
                          </td>
                          <td className='text-center'>
                            <span
                              className={`badge badge-light-${
                                contacto.activo === undefined || contacto.activo === 1
                                  ? 'success'
                                  : 'danger'
                              }`}
                            >
                              {contacto.activo === undefined || contacto.activo === 1
                                ? 'Activo'
                                : 'Inactivo'}
                            </span>
                          </td>
                          {isEditing ? (
                            <td className='text-center pe-4'>
                              <div className='d-flex gap-2 justify-content-center'>
                                <button
                                  type='button'
                                  className='btn btn-sm btn-icon btn-light-primary'
                                  onClick={() => onEdit(contacto)}
                                  title='Editar contacto'
                                >
                                  <KTIcon iconName='pencil' className='fs-5' />
                                </button>
                                <button
                                  type='button'
                                  className='btn btn-sm btn-icon btn-light-danger'
                                  onClick={() => onDelete(contacto.id)}
                                  title='Eliminar contacto'
                                >
                                  <KTIcon iconName='trash' className='fs-5' />
                                </button>
                              </div>
                            </td>
                          ) : null}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            <div className='modal-footer'>
              <button type='button' className='btn btn-light' onClick={onClose}>
                Cerrar
              </button>
              {isEditing && ordenados.length > 0 ? (
                <button type='button' className='btn btn-primary' onClick={onAdd}>
                  <KTIcon iconName='plus' className='fs-4 me-2' />
                  Agregar contacto
                </button>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
